import { ButtonProps, CircularProgress } from '@mui/material';
import React from 'react';
import { StyledButton } from './index.styles';

interface Props extends ButtonProps {
  isLoading?: boolean;
  backgroundColor?: string;
  bordercolor?: string;
  textcolor?: string;
  children?: React.ReactNode;
}

export const Button: React.FC<Props> = ({ children, isLoading, ...props }) => (
  <StyledButton disableElevation {...props}>
    {isLoading ? <CircularProgress size={25} /> : children}
  </StyledButton>
);

export default Button;
